(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[196],{

/***/ 6438:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[slug]",
      function () {
        return __webpack_require__(2233);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Blog; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8044);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(982);
/* harmony import */ var _styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_share__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1818);








var __N_SSG = true;
function Blog(param) {
    let { blog , Allblogs  } = param;
    let filteredBlogs = Allblogs.filter((item)=>item.slug !== blog.slug);
    const similar_blogs = filteredBlogs;
    const handleClick = (e)=>{
        gsap.registerPlugin(ScrollToPlugin);
        e.stopPropagation();
        gsap.to(window, {
            duration: 1,
            scrollTo: {
                y: "#firstsec",
                offsetY: 70
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: blog.metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: blog.metaDesc
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.adventureresortkufri.com/blogs/".concat(blog.slug)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (_styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4___default().singleblog_top_banner),
                style: {
                    backgroundImage: "url(".concat(blog.bannerImage, ")")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner_text),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container common_title",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: blog.title
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "".concat((_styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4___default().single_blog), " common_padding"),
                id: "firstsec",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: 'col-12 col-sm-12 col-md-8 col-lg-8"',
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "blogsocialWrap mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                children: "Share On: \xa0"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_5__/* .FacebookShareButton */ .Dk, {
                                                url: "https://www.adventureresortkufri.com/blogs/".concat(blog.slug),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_5__/* .FacebookIcon */ .Vq, {
                                                    size: 32,
                                                    round: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_5__/* .WhatsappShareButton */ .N0, {
                                                url: "https://www.adventureresortkufri.com/blogs/".concat(blog.slug),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_5__/* .WhatsappIcon */ .ud, {
                                                    size: 32,
                                                    round: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_5__/* .TwitterShareButton */ .B, {
                                                url: "https://www.adventureresortkufri.com/blogs/".concat(blog.slug),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_5__/* .TwitterIcon */ .Zm, {
                                                    size: 32,
                                                    round: true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat((_styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4___default().blog_text1), " common_title"),
                                        dangerouslySetInnerHTML: {
                                            __html: blog.content
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat((_styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4___default().recent_blog_sec), " col-12 col-sm-12 col-md-4 col-lg-4"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat((_styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4___default().recent_top), " common_title"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-white",
                                            children: "Recent Posts"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4___default().recent_bottom),
                                        children: similar_blogs && similar_blogs.slice(0, 5).map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "/blogs/".concat(item.slug),
                                                className: (_styles_Pages_Blogs_module_scss__WEBPACK_IMPORTED_MODULE_4___default().recent_bottom_main),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            src: item.bgImage,
                                                            alt: item.title,
                                                            width: 70,
                                                            height: 70
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "m-0 ps-2",
                                                        children: item.title
                                                    })
                                                ]
                                            }, item.slug))
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 982:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"singleblog_top_banner":"Blogs_singleblog_top_banner__0TYS_","banner_text":"Blogs_banner_text__AkqGH","banner_btn":"Blogs_banner_btn__X5MDT","down":"Blogs_down__Y8hV1","single_blog":"Blogs_single_blog__Z0fvt","highlight_div":"Blogs_highlight_div__dGdDO","h5_text":"Blogs_h5_text__IckNK","images_sec":"Blogs_images_sec__dfPkx","blog_text1":"Blogs_blog_text1__PtkDE","recent_blog_sec":"Blogs_recent_blog_sec__NsZtU","recent_top":"Blogs_recent_top__GSthH","recent_bottom":"Blogs_recent_bottom__UcIeK","recent_bottom_main":"Blogs_recent_bottom_main__msa8S"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [755,818,774,888,179], function() { return __webpack_exec__(6438); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);